import request from "@/utils/request";

/* 系统通知列表 */
export function getInfoList(params) {
  return request({
    url: `/sys_notice_log/v1`,
    params,
  });
}

// 系统通知全部已读
export function informAllRead() {
  return request({
    url: "/sys_notice_log/v1",
    method: "PUT",
  });
}

// 系统通知未读数量
export function unreadNotifiesCount(params) {
  return request({
    url: `/sys_notice_log/count/v1`,
    params,
  });
}

// 系统通知详情
export function informDetail(id, params) {
  return request({
    url: `/sys_notice_log/${id}/v1`,
    params,
  });
}

// 获取订单视频
export function getNoticeOrderVideo(id, params) {
  return request({
    url: `/order/video/${id}/v1`,
    params,
  });
}
